import { z } from "zod";
import { CredentialEmail, NormalizedEmail } from "./email";
import { Password } from "./password";

export const RegisterUser = z.object({
    email: NormalizedEmail,
    name: z.string().refine((name) => name.length >= 2, {
        message: "Name must be at least 2 characters long",
    }),
    password: Password,
    code: z.string().refine((code) => code.length > 1, {
        message: "Code must be present",
    }),
});

// PRTL-1375: `email` normalizes (trim + lowercase) before it leaves the
// client, so what the user typed never has to match the stored casing.
export const LoginUser = z
    .object({
        email: CredentialEmail,
        password: z.string(),
    })
    .refine((data) => data.email.trim() !== "" && data.password.trim() !== "", {
        message: "Please enter your credentials",
        path: ["password"],
    });

export const ResetPasswordInput = z.object({
    token: z.string(),
    password: Password,
});

export const ResetPasswordFormSchema = z
    .object({
        password: Password,
        confirmPassword: z.string(),
    })
    .superRefine((data, ctx) => {
        // Only validate confirmPassword when password itself is valid
        const passwordResult = Password.safeParse(data.password);
        if (!passwordResult.success) return;

        if (data.password !== data.confirmPassword) {
            ctx.addIssue({
                code: "custom",
                message: "Passwords do not match",
                path: ["confirmPassword"],
            });
        }
    });

export const VerifyTwoFactorSchema = z.object({
    code: z
        .string()
        .length(6, "Code must be 6 digits")
        .regex(/^\d{6}$/, "Code must be numeric"),
});
